import { useLocalization } from "@fluent/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@narmi/design_system";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router";
import { z } from "zod";
import { PageLayout } from "@lending/components/PageLayout/PageLayout";
import { TextInput } from "@lending/components/TextInput/TextInput";
import { useFlowNavigation } from "@lending/navigation";
import { InfoAlert } from "@lending/pages/Common/components/InfoAlert";
import { PersonalLoanHeroSection } from "@lending/pages/Common/components/PersonalLoanHeroSection";
import { GetStartedFields } from "@lending/types";
import styles from "./GetStarted.module.css";
import type { ReactLocalization } from "@fluent/react";

function createSchema(l10n: ReactLocalization) {
  const requiredMessage = l10n.getString("error-required", null, "Required");
  const invalidEmailMessage = l10n.getString("error-invalid-email", null, "Enter a valid email");

  return z.object({
    email: z.string().min(1, { message: requiredMessage }).email({ message: invalidEmailMessage }),
  });
}

function GetStarted() {
  const { l10n } = useLocalization();
  const schema = createSchema(l10n);
  const { goToStep } = useFlowNavigation();
  const location = useLocation();
  const previousGetStartedState = location.state as GetStartedFields;

  const { handleSubmit, control } = useForm<GetStartedFields>({
    defaultValues: {
      email: previousGetStartedState?.email || "",
    },
    resolver: zodResolver(schema),
  });

  function onSubmit(data: GetStartedFields) {
    goToStep("personal-info", {
      state: {
        from: location.pathname,
        email: data.email,
      },
    });
  }

  return (
    <>
      <PageLayout>
        <div className={styles.container}>
          <PersonalLoanHeroSection />
          <div className={styles.formSectionContainer}>
            <form onSubmit={handleSubmit(onSubmit)} className={styles.formSection} noValidate>
              <TextInput
                control={control}
                name="email"
                label={l10n.getString("personal-info-email-address-label", null, "Email address")}
                type="email"
              />
              <InfoAlert
                message={l10n.getString(
                  "welcome-screen-not-affect-credit-score",
                  null,
                  "Your application will not affect your credit score."
                )}
              />
              <div className="margin--top--l">
                <Button
                  label={l10n.getString("button-label-get-started", null, "Get started")}
                  type="submit"
                />
              </div>
            </form>
          </div>
        </div>
      </PageLayout>
    </>
  );
}

export { GetStarted };
